import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { IconContainer } from 'src/pages/home/component/calendarPanel/Panel.Styled';
import {
    PhysicianPanelHeader,
    PhysicianContentContainer,
    Icon,
    FilterContainer,
    HeaderContainer,
    Title,
} from './index.styled';
import { getBannerHeight } from 'src/utils/util';
import FilterActiveLightNew from 'src/assets/images/FilterActiveLightNew.svg';
import FilterActiveDark from 'src/assets/images/FilterActiveDark.svg';
import FilterInactiveDesktop from 'src/assets/images/FilterInactiveDesktop.svg';
import FilterLight from 'src/assets/images/FilterLight.svg';
import FilterDark from 'src/assets/images/FilterDark.svg';
import PhysicianSearchBox from 'src/pages/more/pages/physicians/components/physicianSearchBox';
import FilterPopoverContainer from 'src/common/refactoredComponents/filter/FilterPopoverContainer';
import AdminFilterBox from 'src/pages/admin/filter';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const AdminHeader = (props) => {
    const { t } = useTranslation();
    const [searchAnchorEl, setSearchAnchorEl] = useState(null);
    const searchIconEl = useRef(null);
    const searchPopoverId = searchAnchorEl ? 'simple-popover' : undefined;
    const [filterAnchorEl, setFilterAnchorEl] = useState(true);
    const filterPopoverId = 'simple-popover';

    const [showSearch, setShowSearch] = useState(false);
    const handleSearchClose = () => {
        setSearchAnchorEl(null);
        setFilterAnchorEl(null);
        setShowSearch((prevState) => !prevState);
    };
    const totalResultsSearch = useSelector(
        (state) => state.AdminReducer.totalSearchRecords
    );

    const adminFilterOpen = useSelector(
        (state) => state.AdminReducer.adminFilterOpen
    );

    const adminSearchOpen = useSelector(
        (state) => state.AdminReducer.adminSearchOpen
    );
    const { appliedView } = useSelector((state) => state.AdminReducer);

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    const [calendarMarginMobile, setCalnederMarginMobile] = useState('');

    useEffectWithErrorLogging(() => {
        setCalnederMarginMobile(
            bannerHeight
                ? getBannerHeight(bannerHeight, '7.6rem !important')
                : ''
        );
    }, [bannerHeight]);

    return (
        <>
            <HeaderContainer adminSearchOpen={adminSearchOpen}>
                <PhysicianPanelHeader calnederMargin={calendarMarginMobile}>
                    <PhysicianContentContainer>
                        <Title>
                            {t('admin.adminHeader.myCaseUsers')}
                            {` (${
                                adminSearchOpen
                                    ? totalResultsSearch
                                        ? totalResultsSearch
                                        : '0'
                                    : props.totalResults &&
                                      props.totalResults.length > 0
                                    ? props.totalResults
                                    : '0'
                            })`}
                        </Title>
                        <FilterContainer>
                            <IconContainer ref={searchIconEl}></IconContainer>
                            <IconContainer>
                                <Icon
                                    id="admin-search-icon"
                                    adminSearchOpen={adminSearchOpen}
                                    mobilePath={
                                        adminSearchOpen
                                            ? FilterDark
                                            : appliedView && appliedView.appliedDistrict && appliedView.appliedRole && appliedView.appliedTerritory &&
                                              ((Object.keys(
                                                  appliedView.appliedDistrict || {}
                                              ).length &&
                                                  appliedView.appliedDistrict
                                                      .id != 'All District') ||
                                                  (Object.keys(
                                                      appliedView.appliedRole || {}
                                                  ).length &&
                                                      appliedView
                                                          .appliedTerritory
                                                          .id !=
                                                          'All Territory') ||
                                                  (Object.keys(
                                                      appliedView.appliedTerritory || {}
                                                  ).length &&
                                                      appliedView.appliedRole
                                                          .id != 'All'))
                                            ? FilterActiveDark
                                            : FilterDark
                                    }
                                    deskPath={
                                        adminSearchOpen
                                            ? FilterInactiveDesktop
                                            : appliedView && appliedView.appliedDistrict && appliedView.appliedRole && appliedView.appliedTerritory &&
                                              ((Object.keys(
                                                  appliedView.appliedDistrict || {}
                                              ).length &&
                                                  appliedView.appliedDistrict
                                                      .id != 'All District') ||
                                                  (Object.keys(
                                                      appliedView.appliedRole || {}
                                                  ).length &&
                                                      appliedView
                                                          .appliedTerritory
                                                          .id !=
                                                          'All Territory') ||
                                                  (Object.keys(
                                                      appliedView.appliedTerritory || {}
                                                  ).length &&
                                                      appliedView.appliedRole
                                                          .id != 'All'))
                                            ? FilterActiveLightNew
                                            : FilterLight
                                    }
                                    onClick={(event) => {
                                        props.handleClick(event);
                                    }}
                                />
                            </IconContainer>
                        </FilterContainer>
                    </PhysicianContentContainer>
                </PhysicianPanelHeader>
            </HeaderContainer>

            <FilterPopoverContainer
                popoverId={searchPopoverId}
                showPopOver={showSearch}
                AnchorEl={searchAnchorEl}
                handleClose={handleSearchClose}
                top={bannerHeight ? `${parseInt(bannerHeight) + 115}px` : '115px'}
            >
                <PhysicianSearchBox
                    onClose={handleSearchClose}
                    setSearchParamValues={props.setSearchParamValues}
                    bannerHeight={bannerHeight}
                />
            </FilterPopoverContainer>
            <FilterPopoverContainer
                popoverId={filterPopoverId}
                showPopOver={adminFilterOpen}
                AnchorEl={filterAnchorEl}
                handleClose={props.handleClose}
                top={bannerHeight ? `${parseInt(bannerHeight) + 115}px` : '115px'}
                right="18px"
                left="unset"
            >
                <AdminFilterBox
                    onClose={props.handleClose}
                    adminUserList={props.adminUserList}
                    setAdminFilterParamValues={props.setAdminFilterParamValues}
                    bannerHeight={bannerHeight}
                />
            </FilterPopoverContainer>
        </>
    );
};

export default AdminHeader;
